export default "__VITE_ASSET__j2VB_fP5__"